import { UiService } from './../../../shared/services/ui/ui.service';
import { NotificationService } from '@services/notifications/notification.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Alert } from '@classes/alert/alert';
import { Camera } from '@classes/camera/camera';
import { Media } from '@classes/media/media';
import { environment } from '@environments/environment';
import { faLink, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { mediaService, MediaTest } from '@services/media/media.service';
import * as moment from 'moment';
import { VideoTimelineComponent } from '../video-timeline/video-timeline.component';

import { VideoWasteComponent } from '../video-waste/video-waste.component';
import { UserService } from '@services/user/user.service';
import { DomSanitizer } from '@angular/platform-browser';
const reader = new FileReader();

@Component({
  selector: 'app-miniature',
  templateUrl: './miniature.component.html',
  styleUrls: ['./miniature.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class MiniatureComponent implements OnInit {
  alert: Alert;
  index: number;
  choiceDateForm: UntypedFormGroup;
  safeUrl: any;
  camera: Camera[];
  time: string;
  img: any;
  faSearch = faSearch;
  faTrash = faTrash;
  isLinear = false;
  today = new Date();
  firstFormGroup: UntypedFormGroup;
  isOptional = false;
  secondFormGroup: UntypedFormGroup;
  falink = faLink;
  images: any[] = [];
  isLoading = false;
  isLoadingCarousel = false;
  isShown: boolean = false;
  hours: any[];
  toppings = new UntypedFormControl();
  mediasFiltered: Alert[];
  url: string;
  loading: boolean;
  thumnailsId: string[];
  page = 1;
  thumbnails: any[];
  mediaRequest: Media[];
  medias: Media[] = [];
  displayedColumns: string[] = [
    'date',
    'name',
    'progression',
    'video',
    'delete',
  ];
  dataSource: MatTableDataSource<Media>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  length: number;
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private mediaService: mediaService,
    private _formBuilder: UntypedFormBuilder,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private cameraService: CamerasService,
    private notificationsSrv: NotificationService,
    private userService: UserService,
    private uiSrv: UiService
  ) {}

  ngOnInit(): void {
    this.getCameras();
    this.initForm();
    this.initHourSelect();
    this.GetMediaRequest();
    this.initSubscription();

    this.userService.clientChangedSubject.subscribe(() => {
      this.GetMediaRequest();
      this.getCameras();
    });
  }

  initSubscription() {
    this.notificationsSrv.notificationsSubject.subscribe((result) => {
      if (result) {
        this.GetMediaRequest(); // met à jour le tableau après réception d'une notif
      }
    });
  }

  onSubmit(changeCamera: boolean): void {
    this.isLoadingCarousel = true;
    const cameraAlerte = this.f.camera.value ?? null;
    this.getMedias(this.choiceDateForm.value);
    sessionStorage.setItem(
      'choiceDateForm',
      JSON.stringify(this.choiceDateForm.value)
    );
    // this.filteredMedias(this.medias);
  }

  onChange() {
    if (this.choiceDateForm.value.hours.length > 2) {
      this.choiceDateForm.get('hours').setErrors({ invalid: true });
    } else {
      this.choiceDateForm.get('hours').markAsPristine();
    }
  }

  returnImgUrl(img: string) {
    return img;
  }

  toggleShow() {
    this.isShown = !this.isShown;
  }

  private getMedias(formValue?) {
    let filters = null;
    if (formValue) {
      filters = formValue;
    }
    let hours = filters.hours;
    let days = parseInt(
      moment(filters.date).parseZone().utc().local().format('DD')
    );
    let months = parseInt(
      moment(filters.date).parseZone().utc().local().format('MM')
    );
    let years = parseInt(
      moment(filters.date).parseZone().utc().local().format('YYYY')
    );
    this.images = [];
    this.mediaService.getMedias(filters).subscribe((medias) => {
      this.medias = medias.filter((media) => {
        if (hours.length === 1) {
          const dateSplit = media.externalId
            .replace(/\_/g, '-')
            .replace(/\.jpg/g, '')
            .split('-');
          let newDate = `${dateSplit[0]}/${dateSplit[1]}/${dateSplit[2]} ${dateSplit[3]}:${dateSplit[4]}`;
          let hour = parseInt(
            moment(newDate).parseZone().utc().local().format('HH')
          );
          let day = parseInt(
            moment(newDate).parseZone().utc().local().format('DD')
          );
          let month = parseInt(
            moment(newDate).parseZone().utc().local().format('MM')
          );
          let year = parseInt(
            moment(newDate).parseZone().utc().local().format('YYYY')
          );

          return (
            hour === hours[0] &&
            day === days &&
            month === months &&
            year === years
          );
        } else {
          const dateSplit = media.externalId
            .replace(/\_/g, '-')
            .replace(/\.jpg/g, '')
            .split('-');
          let newDate = `${dateSplit[0]}/${dateSplit[1]}/${dateSplit[2]} ${dateSplit[3]}:${dateSplit[4]}`;
          let hour = parseInt(
            moment(newDate).parseZone().utc().local().format('HH')
          );
          let day = parseInt(
            moment(newDate).parseZone().utc().local().format('DD')
          );
          let month = parseInt(
            moment(newDate).parseZone().utc().local().format('MM')
          );
          let year = parseInt(
            moment(newDate).parseZone().utc().local().format('YYYY')
          );
          return (
            hour >= hours[0] &&
            hour <= hours[1] &&
            day === days &&
            month === months &&
            year === years
          );
        }
      });
      // this.filteredMedias(medias);
      this.isLoadingCarousel = false;
    });
  }

  filteredMedias(medias: Media[]): void {
    this.thumbnails = [];

    for (const m of medias) {
      const dateSplit = m.externalId
        .replace(/\_/g, '-')
        .replace(/\.jpg/g, '')
        .split('-');
      const date = new Date(
        +dateSplit[0],
        +dateSplit[1] - 1,
        +dateSplit[2],
        +dateSplit[3],
        +dateSplit[4]
      );
      const checkDate = this.f.date.value.getDate() === date.getDate();
      const checkMonth = this.f.date.value.getMonth() === date.getMonth();
      const checkYear = this.f.date.value.getFullYear() === date.getFullYear();
      const checkTime =
        this.f.hours.value.findIndex((h) => h === +date.getHours()) !== -1
          ? true
          : false;

      if (checkDate && checkMonth && checkYear && checkTime) {
        this.thumbnails.push(m);
      }
    }
  }

  openDialogInfoCamera(element: Media, id: string, alert: Alert): void {
    const dialogRef = this.dialog.open(VideoTimelineComponent, {
      data: {
        mediaId: element.id,
        length: this.dataSource?.filteredData?.length,
        alert: element,
      },
    });
  }

  getPourcentagePackage(media: Media): number {
    return +(
      (100 / media.uploadSession?.totalChunks) *
      media?.uploadSession?.uploadedChunks
    ).toFixed(2);
  }

  private initHourSelect(): void {
    this.hours = Array(24).fill(1);
  }

  GetMediaRequest(): void {
    this.mediaService.getMediaRequest().subscribe((res) => {
      this.mediaRequest = res.filter((el) => el.uploadSession).reverse();
      this.dataSource = new MatTableDataSource<Media>(this.mediaRequest);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.length = this.mediaRequest.length;
    });
  }

  refresh() {
    this.GetMediaRequest();
    this.uiSrv.showSnackbar('Refresh done');
  }

  getVideoName(media: Media) {
    const dateSplit = media.externalId
      .replace(/\_/g, '-')
      .replace(/\.jpg/g, '')
      .split('-');
    const newDate = `${dateSplit[0]}/${dateSplit[1]}/${dateSplit[2]} ${dateSplit[3]}:${dateSplit[4]}`;
    const dateParseZone = moment(newDate)
      .parseZone()
      .utc()
      .local()
      .format('HH:mm');
    let dateUnderFive = moment(newDate)
      .parseZone()
      .utc()
      .add(-5, 'minutes')
      .local()
      .format('DD/MM/YYYY');
    let hoursUndeFive = moment(newDate)
      .parseZone()
      .utc()
      .add(-5, 'minutes')
      .local()
      .format('HH:mm');
    return dateUnderFive + ' \n' + hoursUndeFive + ' - ' + dateParseZone;
  }

  getCameras(): void {
    this.cameraService.getCameras().subscribe((res) => {
      this.camera = res;
      this.choiceDateForm.get('cameraId')?.setValue(this.camera[0].name);
    });
  }

  private filterTime(time: number): MediaTest[] {
    return this.mediaService
      .getRepeat()
      .filter(
        (i) =>
          new Date(i.date).getHours() >= time &&
          new Date(i.date).getHours() < ++time
      );
  }
  get f() {
    return this.choiceDateForm.controls;
  }
  private initForm(): void {
    let date = new Date();
    let camera = null;
    let hours = [date.getHours()];
    if (sessionStorage.getItem('choiceDateForm') != null) {
      const sessionStored = JSON.parse(
        sessionStorage.getItem('choiceDateForm')
      );
      date = new Date(sessionStored.date);
      camera = sessionStored.camera;
      hours = sessionStored.hours;
    }

    this.choiceDateForm = this._formBuilder.group({
      date: [date],
      hours: [hours, Validators.required],
      camera: [camera, Validators.required],
    });
  }

  public idDelete = [];
  checkboxChanger(event) {
    const id = event.source.id;
    this.idDelete.push(id);
  }

  delete() {
    this.mediaService.delete(this.idDelete).subscribe({
      next: () => this.GetMediaRequest(),
    });
  }
}
